import type { Mapper } from '@/core/mapper/base-mapper';
import type { GetStepKeyResultsResponseDTO } from '@/core/dto/bera';
import type { BeraReportV2StepKeyResult, BeraStepKeyReference } from '@/types/Bera';

const NO_TASK_RPN = 0;

export class GetBeraStepKeyResultMapper implements Mapper<BeraReportV2StepKeyResult> {
	constructor(
		private readonly data: GetStepKeyResultsResponseDTO,
		private readonly reference: BeraStepKeyReference
	) {}

	toDomain(): BeraReportV2StepKeyResult {
		const result: BeraReportV2StepKeyResult = {
			id: this.data.id,
			step_id: this.reference.step_id,
			step_key_id: this.reference.step_key_id,
			stress_level_id: this.data.stress_level_id ?? null,
			frequency_id: this.data.frequency_id ?? null,
			total_task_duration_id: this.data.total_task_duration_id ?? null,
			job_element: this.data.job_element ?? null,
			task_rpn: this.data.task_rpn ?? NO_TASK_RPN
		};

		return result;
	}
}
